<template>
  <div>
    <TagsManagement></TagsManagement>
    <v-divider />
    <StatusManagement></StatusManagement>
  </div>
</template>

<script>
import TagsManagement from './TagsManagement'
import StatusManagement from './StatusManagement'
export default {
  components: {
    TagsManagement,
    StatusManagement
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/TagsAndStatus.vue